export enum CreateCatalogSteps {
  CREATE_CATALOG = 0,
  CREATE_MATCHING_RULES = 1,
}
